// console.log("Roof Calculator");
var tag1 = "";
var tag2 = "Corramet Roof Calc";
var tag3 = "Corramet Flashings and Fixings";
var rfnm = 1;
var sheets = 0;
var collection1 = 0;
var collection2 = 0;
var lntha = 0;
var lnthb = 0;
var lnthc = 0;
var double = 1;
var quantity = 1;
var clrcart = 0;
var products = [];
var products1 = [];
var products2 = [];
var colours1 = [];
var colours2 = [];
var colour1 = '';
var colour2 = '';
var mycart = [];
var newcart = [];
var mcaheaders = {method: 'get', headers: new Headers({'Authorization': 'Token 56e79298c2a7bf646d367522b3e2350ee6841de1','Content-Type': 'application/x-www-form-urlencoded'})};
var apiurl = 'https://myclearamber.com/mycapi/v1/cashop/';
if("cas.grokurv.co.uk" == window.location.hostname){
  var apiurl = 'https://myclearamber.com/mycapi/v1/cashopDev/';
}

$(".roofcal .roofimg").click(function(){
  	tag1 = $(this).attr('title');
  	rfnm = $(this).attr('key');
  	$('.rooftype, .roofsize').hide();
  	$('.roofsheet').show();
  	$('.roofsheet img').attr('src',$(this).find('img').attr('src'));
  	$('.roofsheet img').attr('key',$(this).find('img').attr('src'));
  	$('.roofsize img').attr('src',$(this).find('img').attr('src'));
  	$('.roofsize img').attr('key',$(this).find('img').attr('src'));
  	collection11();
  	collection22();
//   	$('.roofselect .crs, .roofselect .rscolor').trigger('onChange').attr('disabled','disabled');
  	if(tag1 == 'Apex – Free Standing' || tag1 == 'Apex – Lean To'){
    	double = 2;
    }
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("complete");
  	$(".roofcal .number.yrc").addClass("current");
});

$(".roofcal .yrc").click(function(){
  	if(tag1 == ''){
    	return false;
    }
  	$('.rooftype, .roofsize').hide();
  	$('.roofsheet').show();
	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("complete");
  	$(".roofcal .number.yrc").addClass("current");
})

$('.crs').change(function(){
  	tag2 = $(this).val();
  	collection11();
})

function collection11(){
  	console.log("Test new");
  	var colfltr = tag1+" || "+tag2;
  	var tags = fetch("https://myclearamber.com/mycapi/v1/cashop/products/?ctag="+colfltr, mcaheaders)
      .then(response => response.json())
      .then(data => {
//         				console.log(data['results']);
//         				collection1 = data['collections'][0];
        				collection1 = data['results'][0];
        				products1 = data['results'];
//         				console.log(products1);
        				cproducts(data['results'], 1);
        				return data 
                    });
}

$('.rscolor').change(function(){
  	tag3 = $(this).val();
  	collection22();
})

function collection22(){
	var colfltr = tag1+" || "+tag3;
//   	var tags = fetch("/admin/api/2022-01/collections.json?title="+colfltr)
  	var tags = fetch("https://myclearamber.com/mycapi/v1/cashop/products/?ctag="+colfltr, mcaheaders)
      .then(response => response.json())
      .then(data => {
//         				collection2 = data['collections'][0];
        				collection2 = data['results'][0];
        				products2 = data['results'];
//         				cproducts(products2, 1);
//         				cproducts(collection2['id'], 2);
        				return data 
                    });
}

$('select[name="colour1"]').change(function(){
  	clearCart();
  	newcart = [];
  	colour1 = $(this).val();
  	$('.roofselect button').attr('disabled',false);
	$('.products .tag1 select[name="COLOUR"]').val(colour1);
  	$('.products .tag1 select[name="COLOUR"]').attr('disabled','disabled');
  	if(tag2 == 'Corrapol-BT Sheets'){ $('select[name="colour2"]').val(colour1).trigger('change'); colour2 = colour1; }
  	var img = tag1.replaceAll('– ','');
  	img = img.replaceAll(' ','_')+"_"+rfnm;
  	var crtimg = $(".roofsheet img").attr("key");
  	$(".roofsheet img, .roofsize img").attr("src",crtimg.replace(img,"Corramet_"+img+"_"+colour1));
})

$('select[name="colour2"]').change(function(){
  	colour2 = $(this).val();
	$('.products .tag2 select[name="COLOUR"]').val(colour2);
  	$('.products .tag2 select[name="COLOUR"]').attr('disabled','disabled');
})

$('.rfsize').click(function(){
    if(tag2 == ''){
      	alert("Please select Roof Sheet Type");
      	return false;
    }
  	if(tag3 == ''){
      	alert("Please select Colour of Glazing Bars");
    	return false;
    }
  	if(tag1 == 'Apex – Free Standing' || tag1 == 'Apex – Lean To'){
//     	$('.roofszc').show();
      	$('.roofszc').hide();
    }else{
    	$('.roofszc').hide();
    }
    if(colour1 == ''){
      alert("Please select Colours First?");
      return false;
    }
  	$('.rooftype').hide();
  	$('.roofsheet').hide();
  	$('.roofsize').show();
//   	$('.products').show();
  	
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor, .roofcal .number.yrc").addClass("complete");
  	$(".roofcal .number.cyrs").addClass("current");
})

$('.srtype').click(function(){
	$('.rooftype').show();
  	$('.roofsheet').hide();
  	$('.roofsize').hide();
  	$('.products').html('').hide();
//   	$('input, select').val('');
  	$('.colour1, .colour2').hide();
  	
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("current");
})


function cproducts(pdata, tg){
	products = products.concat(pdata);
    if(tg == 1){
//       products1 = data['products'];
      variants(products1, tg);
      for(let i = 0; i < products1[0]['options'].length; i++){
        if(products1[0]['options'][i]['name']=='COLOUR'){
          colours1 = products1[0]['options'][i]['values'];
          clroption(colours1, 1);
        }
      }
    }
    if(tg == 2){ 
      products2 = data['products'];
      variants(products2, tg);
      for(let i = 0; i < products2[0]['options'].length; i++){
        if(products2[0]['options'][i]['name']=='COLOUR'){
          colours2 = products2[0]['options'][i]['values'];
          clroption(colours2, 2);
        }
      }
    }
    if(collection1 != 0 && collection2 != 0){
      //           variants(tg);
    }
}

function variants(products, tg=1){
  	var allprod = '';
  	for(let i = 0; i < products.length; i++){
      	var options = '';
      	var optcls = '';
      	var ttl = '';
      	var tgstr = JSON.stringify(products[i]['tags']);
      	for(let j = 0; j < products[i]['options'].length; j++){
          drp = '';
          optcls = optcls+' '+products[i]['options'][j]['name'];
          for(let k = 0; k < products[i]['options'][j]['values'].length; k++){
          	drp += '<option>'+products[i]['options'][j]['values'][k].replaceAll("m","")+'</option>';
          }
          options += '<div>'+products[i]['options'][j]['name']+' <select name="'+products[i]['options'][j]['name']+'">'+drp+'</select> </div>';
      	}
      	if(tgstr.indexOf('PRODUCT') > 0){ ttl = tgstr.substring(tgstr.indexOf('PRODUCT'), tgstr.indexOf('PRODUCT')+9) }
      	allprod +='<div class="w-100 tag'+tg+' '+ttl.replace(' ','')+' prod'+products[i]['id']+' option'+products[i]['options'].length+' '+optcls+' "><div class="w-20 image"> <img src="'+products[i]['images'][0]['src']+'" alt="'+products[i]['title']+'" title="'+ttl+'"></div><div class="w-20">'+products[i]['title']+'</div><div class="w-20">'+options+'</div><div class="w-20"><input type="number" class="quantity" value="1"></div><div class="w-20 total"></div></div>';
    }
  	$('.products').append(allprod);
}

$('.ckit').click(function(){
  	$(this).attr("disabled","disabled");
  	clearCart();
  	$('.products .total').html('');
  	lntha = parseInt($('.roofinput input[name="lengtha"]').val());
  	lnthb = parseInt($('.roofinput input[name="lengthb"]').val());
  	if(lntha < 99 || lnthb < 99){
    	alert("Please enter the valid length and width");
      	return false;
    }
  	for(let i = 0; i < products.length; i++){
    	if(products[i]['options'].length == 1){
          quantitycal(products[i], i);
        }
    }
  	// lengthCal(products2);
  	updateCart();
})


function quantitycal(prdt, index){
  var lengthq = 1;
  var widthq = 1;
  if(lntha > 950){
//     lntha -= 100;
    lengthq = parseInt((lntha-100)/850)+1;
  }
  if(lnthb > 2000){
//     lnthb -= 150;
    widthq = parseInt((lnthb-150)/1850)+1;
  }
  quantity = lengthq*widthq;
  $('.products .option1 .quantity').val(quantity*double);		// Fill the Quantity
  $('.products .PACK .quantity').val(quantity*double*2);		// Fill the pack quantity
  return quantity*double;
}

function clroption(colours, tg){
  if(tg == 1){
    var sltclr = 'Select Colour';
    if(window.location.pathname.indexOf('fr-fr') == 1){ sltclr = 'Sélectionnez la couleur'; }
    var nclr = '<option value="">-- '+sltclr+' --</option>';
    for(let i=0; i< colours.length; i++){
//     	$('select[name="colour1"]').append('<option>'+colours[i]+'</option>');
      var fclr = colours[i];
      if(window.location.pathname.indexOf('fr-fr') == 1 && fclr == 'Black'){ fclr = "Noire"; }
      if(window.location.pathname.indexOf('fr-fr') == 1 && fclr == 'Green'){ fclr = "Verte"; }
      nclr += '<option value="'+colours[i]+'">'+fclr+'</option>';
    }
    $('select[name="colour1"]').html(nclr);
    $('select[name="colour1"]').show();
  }
  if(tg == 2){
    for(let i=0; i< colours.length; i++){
    	$('select[name="colour2"]').append('<option>'+colours[i]+'</option>');
    }
    $('select[name="colour2"]').show();
    if(tag2 == 'Corrapol-BT Sheets'){
      $('select[name="colour2"]').hide();
    }
  }
}

function updateCart(){
  // for(let p=0; p<products1.length; p++){
  //   for(let v=0; v<products1[p]['variants'].length; v++){
  //     if(products1[p]['variants'][v]['title'] == colour1+' / 2000mm'){  // products1[p]['variants'][v]['title'] == colour1
  //       $('.products .tag1 .total').html("SKU : <strong>"+products1[p]['variants'][v]['sku']+"</strong> Variant ID : "+products1[p]['variants'][v]['id']);
  //       newcart.push({"sno":"PRODUCT1","product":products1[p]['id'], "title":products1[p]['variants'][v]['title'], "variant":products1[p]['variants'][v]['vid'], "sku":products1[p]['variants'][v]['sku'], "quantity":quantity*double, "class":"COLOUR", "tag":1});
  //     }
  //   }
  // }

  for(let p=0; p<products1.length; p++){
    var lacal = parseInt((lntha-150)/850)+1;
    var amult = 1;
    if(tag1 == 'Apex – Free Standing' || tag1 == 'Apex – Lean To'){ amult = 2; }
    
    let noptions = products1[p]['options'][1]['values'].toString().replaceAll('mm','').replaceAll(' ','').split(',').sort();
    noptions = noptions.map(function(element) { if(element > 20){ return parseInt(element); } return parseInt(element)*1000; }).sort((a, b) => a - b);
    var sizeb = noptions[noptions.length-1];
    var newlth = lnthb%sizeb;
    for(let v=0; v<products1[p]['variants'].length; v++){
      if(products1[p]['variants'][v]['title'] == colour1+' / '+sizeb+'mm'){
        var qty1 = parseInt(lnthb/sizeb);
        sheets = sheets+(qty1*lacal)*amult;
        // console.log(sheets, "Top 1", double, lacal);
        newcart.push({"sno":"PRODUCT1","product":products1[p]['id'], "quantity":(qty1*lacal)*amult, "title":products1[p]['variants'][v]['title'], "variant":products1[p]['variants'][v]['vid'], "sku":products1[p]['variants'][v]['sku'], "class":"COLOUR", "tag":1});
      }
    }
    for (let b = 0; b < noptions.length; b++) {
      if(newlth <= noptions[b]){
        sizeb = noptions[b];
        break;
      }
    }
    for(let v=0; v<products1[p]['variants'].length; v++){
      if(newlth != 0 && products1[p]['variants'][v]['title'] == colour1+' / '+sizeb+'mm'){  // products1[p]['variants'][v]['title'] == colour1
        sheets = sheets+(1*lacal);
        // console.log(sheets, "Top 2", double, lacal);
        newcart.push({"sno":"PRODUCT1","product":products1[p]['id'], "quantity":1*lacal*amult, "title":products1[p]['variants'][v]['title'], "variant":products1[p]['variants'][v]['vid'], "sku":products1[p]['variants'][v]['sku'], "class":"COLOUR", "tag":1});
      }
    }
    // console.log(sheets);
  }

    lengthCal(products2);

    // var citems = [];
    // for(let c=0; c<newcart.length; c++){
    //   if (JSON.stringify(citems).indexOf(newcart[c]['variant']) > 0){
    //     for (let v = 0; v < citems.length; v++) {
    //       if (citems[v]['id']) { citems[v]['quantity'] = citems[v]['quantity']+newcart[c]['quantity']; }
    //     }
    //   }else{
    //     citems.push({"quantity":newcart[c]['quantity'], "id":newcart[c]['variant'], properties: {"ROOF TYPE": tag1, "COLOUR":colour1, "LENGTH A":lntha, "LENGTH B":lnthb, "PRODUCT":newcart[c]['sno'] }});
    //   }
    //   // citems.push({"quantity":newcart[c]['quantity'], "id":newcart[c]['variant'], properties: {"ROOF TYPE": tag1, "COLOUR":colour1, "LENGTH A":lntha, "LENGTH B":lnthb, "PRODUCT":newcart[c]['sno']}});
    // }


    function sortProducts(data) {
      return data.sort((a, b) => {
        const numA = parseInt(a.sno.replace("PRODUCT", ""), 10);
        const numB = parseInt(b.sno.replace("PRODUCT", ""), 10);
        return numA - numB;
      });
    }
    const sortedData = sortProducts(newcart);
  // 	var cartContents = fetch('/cart.js')
  //   		.then(response => response.json())
  //   		.then(data => { mycart=data; return data });
  //  	console.log(mycart);
      // Add Product to Cart
      var citems = [];
      for(let c=0; c<sortedData.length; c++){
        citems.push({"quantity":sortedData[c]['quantity'], "id":sortedData[c]['variant'], properties: {"ROOF TYPE": tag1, "COLOUR":colour1, "LENGTH A":lntha, "LENGTH B":lnthb, "PRODUCT":sortedData[c]['sno']}});
      }
      // console.log(citems);
    citems.reverse();
  
    console.log(citems);
  
  	jQuery.post('/cart/add.js', {
      items: citems
    }).then(data => {
      $(".ckit").attr("disabled",false);
      // window.location.href = '/cart';
      if(window.location.pathname.indexOf('fr-fr') == 1){ window.location.href = '/fr-fr/cart'; }else{ window.location.href = '/cart'; }
    });
}

function lengthCal(prod){
  for(let p = 0; p < products2.length; p++){
    var lthoption = [];
    var ttl = '';
    var tgstr = JSON.stringify(products2[p]['tags']);
    if(tgstr.indexOf('PRODUCT') > 0){ ttl = tgstr.substring(tgstr.indexOf('PRODUCT'), tgstr.indexOf('PRODUCT')+9).replace(' ','') }
//     if(products2[p]['tags'].indexOf('PRODUCT') > 0){ ttl = products2[p]['tags'].substring(products2[p]['tags'].indexOf('PRODUCT'), products2[p]['tags'].indexOf('PRODUCT')+9).replace(' ','') }
    if(ttl == 'PRODUCT3' || ttl == 'PRODUCT7'){
      var multp = 2;
      var nlnthb = lnthb;
      if (tag1 == 'Single Slope – Lean To Against Back and Side Wall') { multp = 1; }
      if (ttl == 'PRODUCT3' && tag1 == 'Apex – Free Standing') { multp = 4; }
      if (ttl == 'PRODUCT7'){ multp = 1; }
      if (ttl == 'PRODUCT7' && tag1 == 'Apex – Lean To') { nlnthb = nlnthb*2; }
      
      let noptions = products2[p]['options'][1]['values'].toString().replaceAll('mm','').replaceAll(' ','').split(',').sort();
      noptions = noptions.map(function(element) { if(element > 20){ return parseInt(element); } return parseInt(element)*1000; }).sort((a, b) => a - b);
      var sizeb = noptions[noptions.length-1];
      var newlth = nlnthb%sizeb;
      for(let v=0; v<products2[p]['variants'].length; v++){
        // console.log(products2[p]['variants'][v], sizeb, newlth);
        if(products2[p]['variants'][v]['title'] == colour1+' / '+(sizeb/1000).toFixed(1)+'m'){
          var qty3 = parseInt(nlnthb/sizeb);
          // console.log(qty3, "TOP 1");
          newcart.push({"sno":ttl,"product":products2[p]['id'], "quantity":qty3*multp, "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"COLOUR", "tag":1});
        }
      }
      for (let b = 0; b < noptions.length; b++) {
        if(newlth <= noptions[b]){
          sizeb = noptions[b];
          break;
        }
      }
      for(let v=0; v<products2[p]['variants'].length; v++){
        // console.log('1 qty m', 1*multp);
        // console.log(qty3, "TOP 2");
        if(newlth != 0 && products2[p]['variants'][v]['title'] == colour1+' / '+(sizeb/1000).toFixed(1)+'m'){
          newcart.push({"sno":ttl,"product":products2[p]['id'], "quantity":1*multp, "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"COLOUR", "tag":1});
        }
      }
      
      console.log(ttl, lnthb, products2[p]['options'][1]['values'], noptions)
    }
    if(ttl == 'PRODUCT4' || ttl == 'PRODUCT8'){
      let noptions = products2[p]['options'][1]['values'].toString().replaceAll('mm','').replaceAll(' ','').split(',').sort();
      noptions = noptions.map(function(element) { if(element > 20){ return parseInt(element); } return parseInt(element)*1000; }).sort((a, b) => a - b);
      var sizeb = noptions[noptions.length-1];
      var newlth = lntha%sizeb;
      for(let v=0; v<products2[p]['variants'].length; v++){
        // console.log(products2[p]['variants'][v], sizeb, newlth);
        if(products2[p]['variants'][v]['title'] == colour1+' / '+(sizeb/1000).toFixed(1)+'m'){
          var qty4 = parseInt(lntha/sizeb);
          newcart.push({"sno":ttl,"product":products2[p]['id'], "quantity":qty4, "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"COLOUR", "tag":1});
        }
      }
      for (let b = 0; b < noptions.length; b++) {
        if(newlth <= noptions[b]){
          sizeb = noptions[b];
          break;
        }
      }
      for(let v=0; v<products2[p]['variants'].length; v++){
        if(newlth != 0 && products2[p]['variants'][v]['title'] == colour1+' / '+(sizeb/1000).toFixed(1)+'m'){
          newcart.push({"sno":ttl,"product":products2[p]['id'], "quantity":1, "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"COLOUR", "tag":1});
        }
      }
      // console.log(newcart);
    }
    
    for(let opt = 0; opt < products2[p]['options'].length; opt++){
      // if(ttl == 'PRODUCT3' && tag1 == 'Apex – Free Standing'){
      // 	double = 4;
      // }
      // if(products2[p]['options'][opt]['name']=='LENGTH'){
      //   let oroption = products2[p]['options'][opt]['values'];
      //   let noptions = oroption.toString().replaceAll('m','').split(',').sort();
      //   noptions = noptions.map(function(element) { if(element > 20){ return element; } return element*1000; })
      //   // if(ttl == 'PRODUCT3' || ttl == 'PRODUCT7'){
      //   if(ttl == 'PRODUCT7'){
      //   	lengthOnly(lnthb, noptions, lthoption, oroption, ttl);
      //   }else{
      //   	lengthOnly(lntha, noptions, lthoption, oroption, ttl);
      //   }
        
      // }
      
      if(ttl == 'PRODUCT5'){
        newcart.push({"sno":"PRODUCT5", "quantity":sheets, "product":products2[p]['id'], "title":products2[p]['variants'][0]['title'], "variant":products2[p]['variants'][0]['vid'], "sku":products2[p]['variants'][0]['sku'], "class":"WIDTH", "tag":2});
      }
      if(ttl == 'PRODUCT6' && tag1 == 'Single Slope – Lean To Against Back Wall'){
        qt6 = parseInt((lntha)/10000);
        if((lntha)%10000 != 0){ qt6 += 1; }
        $('.products .PRODUCT6 input').val(qt6);
        newcart.push({"sno":"PRODUCT6","product":products2[p]['id'], "title":products2[p]['variants'][0]['title'], "variant":products2[p]['variants'][0]['vid'], "sku":products2[p]['variants'][0]['sku'], "quantity":qt6, "class":"WIDTH", "tag":2});
      }
      if(ttl == 'PRODUCT6' && tag1 == 'Single Slope – Lean To Against Back and Side Wall'){
        qt6 = parseInt((lntha+lnthb)/10000);
        if((lntha+lnthb)%10000 != 0){ qt6 += 1; }
        $('.products .PRODUCT6 input').val(qt6);
        newcart.push({"sno":"PRODUCT6","product":products2[p]['id'], "title":products2[p]['variants'][0]['title'], "variant":products2[p]['variants'][0]['vid'], "sku":products2[p]['variants'][0]['sku'], "quantity":qt6, "class":"WIDTH", "tag":2});
      }
      if(ttl == 'PRODUCT6' && tag1 == 'Apex – Lean To'){
        qt6 = parseInt((2*lnthb)/10000);
        if((2*lnthb)%10000 != 0){ qt6 += 1; }
        $('.products .PRODUCT6 input').val(qt6);
        newcart.push({"sno":"PRODUCT6","product":products2[p]['id'], "title":products2[p]['variants'][0]['title'], "variant":products2[p]['variants'][0]['vid'], "sku":products2[p]['variants'][0]['sku'], "quantity":qt6, "class":"WIDTH", "tag":2});
      }
      // if(ttl != 'PRODUCT8' && (tag1 == 'Apex – Free Standing' || tag1 == 'Apex – Lean To')){
      // 	double = 2;
      // }else{
      // 	double = 1;
      // }
      if(ttl == 'PRODUCT9'){
        qt9 = 1;
        if(tag1 =='Apex – Free Standing'){ qt9=2; }
        for(let v = 0; v < products2[p]['variants'].length; v++){
          if(products2[p]['variants'][v]['title'] == colour1){
          	newcart.push({"sno":"PRODUCT9", "quantity":qt9,"product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
          }
        }
      }
    }
    // $('.products .'+products2[p]["id"]+' .total').html("");
    // for(let v = 0; v < products2[p]['variants'].length; v++){
    //   for(let l = 0; l < lthoption.length; l++){
    //     if(lthoption.length > 0 && products2[p]['variants'][v]['title'] == colour1+' / '+lthoption[l]['length']){
    //         console.log("Last Default ==== ", ttl);
    //       	newcart.push({"sno":ttl,"quantity":lthoption[l]['quantity'], "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"LENGTH "+ttl, "tag":2});
    //     }
    //   }
    // }
  }
//   console.log(newcart);
}

function lengthOnly(input, nopt, lthoption, oroption, ttl){
  	console.log(input, nopt, lthoption, oroption, ttl, tag1);
  	var mult = 1;
  	if((ttl == 'PRODUCT3') && (tag1 == 'Single Slope – Free Standing' || tag1 == 'Single Slope – Lean To Against Back Wall')){ mult = 2; }
	if(input > nopt[nopt.length-1]){	// nopt.at(-1)
      var max = parseInt(input/nopt.at(-1));
      var rem = input%nopt.at(-1);
      lthoption.push({"length":oroption.at(-1),"quantity":max*mult*double});
      for(let k = 0; k < nopt.length; k++){
        let looplnth = parseFloat(nopt[k]);
        if(rem <= looplnth){
          lthoption.push({"length":oroption[k],"quantity":1*mult*double});
          break;
        }
      }
    }else{
      for(let k = 0; k < nopt.length; k++){
        let looplnth = parseFloat(nopt[k]);
        if(input <= looplnth){
          lthoption.push({"length":oroption[k],"quantity":1*mult*double});
          break;
        }
      }
    }
}

function clearCart(){
  	clrcart = 1;
  	newcart = [];
	$.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() { 
//             Shopify.clear();
          clrcart = 0;
        },
        error: function(XMLHttpRequest, textStatus) {
          /* error code */
          clrcart = 0;
        }
      });
}